import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "专题合集", to: "/specials" },
  { label: "关于我们", to: "/about" },
];

const hotGenres = ["科幻", "悬疑", "犯罪", "剧情", "爱情", "古装"];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-secondary-950 text-foreground-400">
      <div className="h-1 w-full bg-primary-500" />
      <div className="grid grid-cols-1 gap-8 px-4 py-12 sm:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-foreground-950">
              秋
            </span>
            <span className="font-heading text-xl font-semibold text-foreground-950">
              秋霞<span className="text-primary-500">网</span>
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-foreground-400">
            秋霞网致力于为用户提供最新最全的电影和电视剧资源，涵盖多种类型影视内容，方便用户在线观看和了解影视动态。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-900">
            <Link to="/" className="cursor-pointer hover:text-primary-500">
              站点导航
            </Link>
          </h4>
          <ul className="mt-4 space-y-2.5">
            {quickLinks.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="text-sm text-foreground-400 transition-colors hover:text-primary-500 cursor-pointer"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-900">
            <Link to="/category/movie" className="cursor-pointer hover:text-primary-500">
              热门类型
            </Link>
          </h4>
          <div className="mt-4 flex flex-wrap gap-2">
            {hotGenres.map((g) => (
              <Link
                key={g}
                to={`/category/movie`}
                className="rounded-md bg-secondary-800 px-3 py-1 text-xs text-foreground-500 transition-colors hover:bg-secondary-700 hover:text-primary-400 cursor-pointer"
              >
                {g}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-900">联系我们</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-foreground-400">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-500" />
              contact@qiuxia-demo.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-customer-service-2-line text-primary-500" />
              意见反馈：前往关于页提交
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-primary-500" />
              每日 09:00 - 22:00 更新资源
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-secondary-800 px-4 py-6 md:px-6">
        <div className="flex flex-col items-center justify-between gap-3 text-center sm:flex-row sm:text-left">
          <p className="text-xs text-foreground-500">
            © 2026 秋霞网 Qiuxia. 本站为演示站点，所有影视信息均为虚构示例，仅供展示用途。
          </p>
          <p className="text-xs text-foreground-500">
            本站不提供真实在线播放、下载与存储服务，所有内容版权归原权利人所有。
          </p>
        </div>
      </div>
    </footer>
  );
}